import en from "./en"
import ko from "./ko"
import Cookies from "js-cookie"
import { getItem, setItem } from "../modules/Storage"

export type LangCode = "en" | "ko"
const Lang = {
  en: en,
  ko: ko,
}

export class Locale {
  static isIframe() {
    return window != window.top
  }

  static getDefault() {
    const code = Locale.getLangCode()
    // @ts-ignore
    const message = Lang[code]
    return { lang: code, message }
  }
  static setLang(value: LangCode): LangCode {
    const [top, second] = window.location.hostname.split(".").reverse()
    const domain = `.${second}.${top}`
    Cookies.set("locale", value, { expires: 99999, domain: domain })
    if (this.isIframe()) {
      setItem("locale", value)
    }
    return value
  }
  static getLangCode(): string {
    try {
      let langCode = ""
      if (this.isIframe()) {
        langCode = getItem("locale")
      } else {
        // @ts-ignore
        langCode = Cookies.get("locale")
      }
      if (!langCode) {
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
        if (timeZone === "Asia/Seoul") {
          Locale.setLang("ko")
        } else {
          Locale.setLang("en")
        }
      }
    } catch (e) { }

    let langCode = ""
    if (this.isIframe()) {
      langCode = getItem("locale")
    } else {
      // @ts-ignore
      langCode = Cookies.get("locale")
    }
    return langCode || Locale.setLang("en")
  }
  static getMessage() {
    // @ts-ignore
    return Lang[Locale.getDefault().lang]
  }
  static getLangText() {
    const target = Locale.list.find((it) => Locale.isLangCodeOf(it.code as LangCode))!
    return target.text
  }
  static isLangCodeOf(code: LangCode) {
    return Locale.getLangCode() === code
  }
  static list: { text: string; code: LangCode }[] = [
    {
      text: "한국어",
      code: "ko",
    },
    {
      text: "English",
      code: "en",
    },
  ]

  static changeLangAndReload(langCode: LangCode) {
    const beforeLang = this.getLangCode()
    this.setLang(langCode)
    window.location.replace(window.location.pathname.replace(`/${beforeLang}/`, `/${langCode}/`))
  }

  static localeUrl(url: string) {
    return `/${this.getLangCode()}${url}`
  }
}
